"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("styled-components"),r=require("@vds-core/typography"),o=require("@vds-tokens/color"),t=require("react");function a(e){return e&&e.__esModule?e:{default:e}}var l=a(e),s=a(t);const n=l.default.div.withConfig({displayName:"ErrorTextWrapper",componentId:"VDS__sc-13aeuon-0"})`
  margin-top: ${({errorLabelSpacing:e})=>e};
`;exports.default=e=>{const{errorLabelSpacing:t,errorText:a,error:l,success:c,successText:u,surface:i}=e;return s.default.createElement("div",{role:"alert"},s.default.createElement(n,{errorLabelSpacing:t},s.default.createElement(r.Body,{size:"small",color:"dark"===i?o.ColorTokens.elements.primary.ondark.value:o.ColorTokens.elements.primary.onlight.value},l?a:c&&u)))};



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/form-elements/cjs/elements/ErrorText.js
// module id = 955
// module chunks = 0